import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: "sm" | "md" | "lg";
  autoFocus?: boolean;
  className?: string;
}

export default function SearchBar({
  defaultValue = "",
  placeholder = "搜索漫画标题、作者或类型",
  size = "md",
  autoFocus = false,
  className = "",
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const sizeClass =
    size === "lg"
      ? "h-14 text-base pl-12 pr-32"
      : size === "sm"
        ? "h-9 text-sm pl-9 pr-20"
        : "h-11 text-sm pl-10 pr-24";

  const iconClass =
    size === "lg" ? "left-4 text-xl" : size === "sm" ? "left-3 text-base" : "left-3.5 text-lg";

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  return (
    <form onSubmit={handleSubmit} role="search" className={`relative w-full ${className}`}>
      <i className={`ri-search-line pointer-events-none absolute top-1/2 -translate-y-1/2 text-foreground-400 ${iconClass}`} />
      <input
        type="search"
        name="q"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索漫画"
        className={`w-full rounded-md border border-background-300 bg-background-50 text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100 ${sizeClass}`}
      />
      <button
        type="submit"
        className={`absolute right-1.5 top-1/2 flex -translate-y-1/2 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 font-semibold text-background-50 transition-colors hover:bg-accent-600 ${
          size === "lg" ? "px-5 py-2.5 text-sm" : "px-3 py-1.5 text-xs"
        }`}
      >
        <i className="ri-search-2-line" />
        搜索
      </button>
    </form>
  );
}